import React, { useState, useCallback } from 'react';
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import './reset-password-form.scss';
import { AuthStore } from '../../common/store';
import { SingleCard } from '../../layouts';
import CusEntInfoStore from '../../main/corp-info/corp-info-store'

// eslint-disable-next-line import/no-anonymous-default-export
export default function () {
  const [loading, setLoading] = useState(false);
  const { cusEntInfo } = CusEntInfoStore;
  const [notifyMsg, setNotifyMsg] = useState();

  const [passwordInfo, setPasswordInfo] = useState({
    newPassword: '',
    newPasswordConfirm: '',
  });

  const onFieldDataChanged = useCallback((e) => {
    const { dataField, value } = e;

    setPasswordInfo((passwordInfo) => ({
      ...passwordInfo,
      [dataField]: value,
    }));
  }, []);

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setLoading(true);
      const result = await AuthStore.updatePassword(passwordInfo, cusEntInfo);
      setLoading(false);

      if (result.error) {
        setNotifyMsg(result.message);
      } else {
        alert('비밀번호가 변경되었습니다. 다시 로그인 해주세요.')
        sessionStorage.removeItem('user');
        AuthStore.setUser(null);
      }
    },
    [passwordInfo, cusEntInfo]
  );

  return (
    <SingleCard
      title="업소고객 관리 시스템"
    >
      <form className={'reset-password-form'} onSubmit={onSubmit}>
        <Form
          disabled={loading}
          formData={passwordInfo}
          onFieldDataChanged={onFieldDataChanged}
        >
          <Item
            dataField={'newPassword'}
            editorType={'dxTextBox'}
            editorOptions={{
              stylingMode: 'filled',
              placeholder: '새 비밀번호',
              mode: 'password',
            }}
          >
            <RequiredRule message="새 비밀번호를 입력해주세요." />
            <Label visible={false} />
          </Item>
          <Item
            dataField={'newPasswordConfirm'}
            editorType={'dxTextBox'}
            editorOptions={{
              stylingMode: 'filled',
              placeholder: '새 비밀번호 확인',
              mode: 'password',
            }}
          >
            <RequiredRule message="새 비밀번호 확인을 입력해주세요." />
            <Label visible={false} />
          </Item>
          <ButtonItem>
            <ButtonOptions
              elementAttr={{ class: 'submit-button' }}
              width={'100%'}
              height={'50px'}
              type={'default'}
              useSubmitBehavior={true}
            >
              <span className="dx-button-text" style={{ fontSize: '20px' }}>
                {loading ? (
                  <LoadIndicator
                    width={'24px'}
                    height={'24px'}
                    visible={true}
                  />
                ) : (
                  '비밀번호변경'
                )}
              </span>
            </ButtonOptions>
          </ButtonItem>
          <Item>
            <span className="notify-error"> {notifyMsg} </span>
          </Item>
        </Form>
      </form>
    </SingleCard>
  );
}
